module.exports = __webpack_public_path__ + "img/06.0f4cba96.png";